/* eslint-disable @typescript-eslint/no-unused-expressions */
import { ButtonHigh, ButtonLow, Wrapper } from './ButtonCard.style'

export type ButtonCardProps = {
  isOnHigh: boolean
  changeValue: () => void
}

export function ButtonCard({ isOnHigh, changeValue }: ButtonCardProps) {
  return (
    <Wrapper>
      <ButtonHigh
        isOnHigh={isOnHigh}
        onClick={() => {
          !isOnHigh ? changeValue() : ''
        }}
        type="button"
      >
        Em alta
      </ButtonHigh>
      <ButtonLow
        isOnHigh={isOnHigh}
        onClick={() => {
          isOnHigh ? changeValue() : ''
        }}
        type="button"
      >
        Em baixa
      </ButtonLow>
    </Wrapper>
  )
}
